import { ActionBase } from '../../../core/store/action/ActionBase';
import { RuleListModel } from "../../models/RuleListModel";

export const GET_COMMON_PARAMETERS = '[Rule] Get Common Parameters';

export class GetCommonParametersAction implements ActionBase {
  readonly identifier = new Date().getTime().toString();
  readonly type = GET_COMMON_PARAMETERS;

  constructor( public payload: { model: RuleListModel }) {

  }
}



// WEBPACK FOOTER //
// ./src/app/businessRule/store/actions/GetCommonParametersAction.ts